import React, { useRef, useState } from 'react';
import { Loader, Dimmer, TableCell, TableRow, TableBody } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {
  validaSoloNumero
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import useTable from '../useTable';

export const ModalPermisosUsuarisVacios = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  let idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
  let idusuario = JSON.parse(sessionStorage.getItem("idusuario"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtLogin = useRef();
  const txtCedula = useRef();
  const txtStatus = useRef();
  const txtIduser = useRef();

  const txtuTodos = useRef();
  const txtuIncluir = useRef();
  const txtuModificar = useRef();
  const txtuCosultar = useRef();
  const txtuEliminar = useRef();
  const txtuImprimir = useRef();

  const txtdTodos = useRef();
  const txtdIncluir = useRef();
  const txtdModificar = useRef();
  const txtdCosultar = useRef();
  const txtdEliminar = useRef();
  const txtdImprimir = useRef();

  const txttTodos = useRef();
  const txttIncluir = useRef();
  const txttModificar = useRef();
  const txttCosultar = useRef();
  const txttEliminar = useRef();
  const txttImprimir = useRef();

  const txtcTodos = useRef();
  const txtcIncluir = useRef();
  const txtcModificar = useRef();
  const txtcCosultar = useRef();
  const txtcEliminar = useRef();
  const txtcImprimir = useRef();

  const txtcoTodos = useRef();
  const txtcoIncluir = useRef();
  const txtcoModificar = useRef();
  const txtcoCosultar = useRef();
  const txtcoEliminar = useRef();
  const txtcoImprimir = useRef();

  const txtsTodos = useRef();
  const txtsIncluir = useRef();
  const txtsModificar = useRef();
  const txtsCosultar = useRef();
  const txtsEliminar = useRef();
  const txtsImprimir = useRef();

  const txtsiTodos = useRef();
  const txtsiIncluir = useRef();
  const txtsiModificar = useRef();
  const txtsiCosultar = useRef();
  const txtsiEliminar = useRef();
  const txtsiImprimir = useRef();

  const txtoTodos = useRef();
  const txtoIncluir = useRef();
  const txtoModificar = useRef();
  const txtoCosultar = useRef();
  const txtoEliminar = useRef();
  const txtoImprimir = useRef();

  const txtnTodos = useRef();
  const txtnIncluir = useRef();
  const txtnModificar = useRef();
  const txtnCosultar = useRef();
  const txtnEliminar = useRef();
  const txtnImprimir = useRef();

  const txtdzTodos = useRef();
  const txtdzIncluir = useRef();
  const txtdzModificar = useRef();
  const txtdzCosultar = useRef();
  const txtdzEliminar = useRef();
  const txtdzImprimir = useRef();

  const txtocTodos = useRef();
  const txtocIncluir = useRef();
  const txtocModificar = useRef();
  const txtocCosultar = useRef();
  const txtocEliminar = useRef();
  const txtocImprimir = useRef();

  const txtReportTodos = useRef();
  const txtReport1 = useRef();
  const txtReport2 = useRef();
  const txtReport3 = useRef();
  const txtReport4 = useRef();
  const txtReport5 = useRef();
  const txtReport6 = useRef();

  const [modu1, setModu1] = useState(0);
  const [modu2, setModu2] = useState(0);
  const [modu3, setModu3] = useState(0);
  const [modu4, setModu4] = useState(0);
  const [modu5, setModu5] = useState(0);
  const [modu6, setModu6] = useState(0);
  const [modu7, setModu7] = useState(0);
  const [modu8, setModu8] = useState(0);
  const [modu9, setModu9] = useState(0);
  const [modu10, setModu10] = useState(0);
  const [modu11, setModu11] = useState(0);
  const [modu12, setModu12] = useState(0);

  const [body, setBody] = useState({});
  const [operacion, setOperacion] = useState(0);
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });

  const blanquear = () => {
    setActivate(false);
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancela();

  };

  const SelectUsuario = (idusuario) => {
    let endpoint = `${op.conexion}/api/athos/usuario/getuser?id=${idusuario}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idusuario > 0) {

            let para1 = response.data.btnopvacios;
            let para2 = response.data.btncontvacios;
            let para3 = response.data.btnclasvacios;
            let para4 = response.data.btnreportvacios;

            sessionStorage.setItem("btnopvaciosc", JSON.stringify(para1));
            sessionStorage.setItem("btncontvaciosc", JSON.stringify(para2));
            sessionStorage.setItem("btnclasvaciosc", JSON.stringify(para3));
            sessionStorage.setItem("btnreportvaciosc", JSON.stringify(para4));

          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Error al cargar el usuario",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let parameter1 = "";
    let parameter2 = "";
    let parameter3 = "";
    let parameter4 = "";
    let parameter5 = "";
    let parameter6 = "";
    let parameter7 = "";
    let parameter8 = "";
    let parameter9 = "";
    let parameter10 = "";
    let reportes = "";


    if (props.usuario.accvacios.toString().substring(0, 1) === '1') {

      let val1 = txtuIncluir.current.checked === true ? "1" : "0";
      let val2 = txtuModificar.current.checked === true ? "1" : "0";
      let val3 = txtuCosultar.current.checked === true ? "1" : "0";
      let val4 = txtuEliminar.current.checked === true ? "1" : "0";
      let val5 = txtuImprimir.current.checked === true ? "1" : "0";

      parameter1 = val1 + val2 + val3 + val4 + val5;
    } else {

      parameter1 = '000000';

    }

    if (props.usuario.accvacios.toString().substring(1, 2) === '1') {

      let val1 = txtdIncluir.current.checked === true ? "1" : "0";
      let val2 = txtdModificar.current.checked === true ? "1" : "0";
      let val3 = txtdCosultar.current.checked === true ? "1" : "0";
      let val4 = txtdEliminar.current.checked === true ? "1" : "0";
      let val5 = txtdImprimir.current.checked === true ? "1" : "0";

      parameter2 = val2 + val3 + val1 + val4 + val5;
    } else {

      parameter2 = '000000';

    }

    if (props.usuario.accvacios.toString().substring(2, 3) === '1') {

      let val1 = txttIncluir.current.checked === true ? "1" : "0";
      let val2 = txttModificar.current.checked === true ? "1" : "0";
      let val3 = txttCosultar.current.checked === true ? "1" : "0";
      let val4 = txttEliminar.current.checked === true ? "1" : "0";
      let val5 = txttImprimir.current.checked === true ? "1" : "0";

      parameter3 = val1 + val2 + val3 + val4 + val5;
    } else {

      parameter3 = '000000';

    }

    if (props.usuario.accvacios.toString().substring(4, 5) === '1') {

      let val1 = txtReport1.current.checked === true ? "1" : "0";
      let val2 = txtReport2.current.checked === true ? "1" : "0";
      let val3 = txtReport3.current.checked === true ? "1" : "0";
      let val4 = txtReport4.current.checked === true ? "1" : "0";
      let val5 = txtReport5.current.checked === true ? "1" : "0";
      let val6 = txtReport6.current.checked === true ? "1" : "0";

      reportes = val1 + val2 + val3 + val4 + val5 + val6;
    } else {

      reportes = '000000';

    }

    var sigue = true;
    var mensaje = "";

    if (sigue) {
      var user = [];
      user.push({
        idusuario: txtIduser.current.value,
        login: txtLogin.current.value,
        persona: txtCedula.current.value,
        status: txtStatus.current.value === 'ACTIVO' ? 1 : 0,
        idorganizacion: idorganizacion,
        btnopvacios: parameter1,
        btncontvacios: parameter2,
        btnclasvacios: parameter3,
        btnreportvacios: reportes
      });

      let body = {
        usu: JSON.stringify(user),
      };
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
      setBody(body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: mensaje,
        icono: "informacion",
      });
    }
  };

  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/athos/usuario/actualizar/${operacion}`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);

          if (parseInt(response.data.iduser) > 0) {
            if (parseInt(response.data.iduser) === parseInt(idusuario)) {
              SelectUsuario(parseInt(response.data.iduser));
            }
          }

          var mensaje = "";
          if (operacion === 1) {
            mensaje =
              "El Usuario " +
              response.data.iduser +
              " ha sido registrada de manera satisfactoria.";
          } else if (operacion === 2) {
            mensaje =
              "El Usuario " +
              response.data.iduser +
              " ha sido Modificada de manera Satisfactoria.";
          } else if (operacion === 3) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido eliminada de manera satisfactoria.";
          }

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: mensaje,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    procesarRegistro();
  };

  const cerrarModal = () => {
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const checkBlank = (e) => {

    if (modu1 === 1) {
      if (txtuIncluir.current.checked && txtuModificar.current.checked && txtuCosultar.current.checked && txtuEliminar.current.checked &&
        txtuImprimir.current.checked) {
        txtuTodos.current.checked = true;
      } else {
        txtuTodos.current.checked = false;
      }
    }

    if (modu2 === 1) {
      if (txtdIncluir.current.checked && txtdModificar.current.checked && txtdCosultar.current.checked && txtdEliminar.current.checked &&
        txtdImprimir.current.checked) {
        txtdTodos.current.checked = true;
      } else {
        txtdTodos.current.checked = false;
      }
    }

    if (modu3 === 1) {
      if (txttIncluir.current.checked && txttModificar.current.checked && txttCosultar.current.checked && txttEliminar.current.checked &&
        txttImprimir.current.checked) {
        txttTodos.current.checked = true;
      } else {
        txttTodos.current.checked = false;
      }
    }

    if (modu4 === 1) {
      if (txtReport1.current.checked /* && txtReport2.current.checked && txtReport3.current.checked && txtReport4.current.checked &&
        txtReport5.current.checked && txtReport6.current.checked */) {
        txtReportTodos.current.checked = true;
      } else {
        txtReportTodos.current.checked = false;
      }
    }

  };


  const checkTodo = (e) => {
    if (e.target.name === "todos1") {
      if (txtuTodos.current.checked) {
        txtuIncluir.current.checked = true;
        txtuModificar.current.checked = true;
        txtuCosultar.current.checked = true;
        txtuEliminar.current.checked = true;
        txtuImprimir.current.checked = true;
      } else {
        txtuIncluir.current.checked = false;
        txtuModificar.current.checked = false;
        txtuCosultar.current.checked = false;
        txtuEliminar.current.checked = false;
        txtuImprimir.current.checked = false;
      }
    } else if (e.target.name === "todos2") {
      if (txtdTodos.current.checked) {
        txtdIncluir.current.checked = true;
        txtdModificar.current.checked = true;
        txtdCosultar.current.checked = true;
        txtdEliminar.current.checked = true;
        txtdImprimir.current.checked = true;
      } else {
        txtdIncluir.current.checked = false;
        txtdModificar.current.checked = false;
        txtdCosultar.current.checked = false;
        txtdEliminar.current.checked = false;
        txtdImprimir.current.checked = false;
      }
    } else if (e.target.name === "todos3") {
      if (txttTodos.current.checked) {
        txttIncluir.current.checked = true;
        txttModificar.current.checked = true;
        txttCosultar.current.checked = true;
        txttEliminar.current.checked = true;
        txttImprimir.current.checked = true;
      } else {
        txttIncluir.current.checked = false;
        txttModificar.current.checked = false;
        txttCosultar.current.checked = false;
        txttEliminar.current.checked = false;
        txttImprimir.current.checked = false;
      }
    } else if (e.target.name === "todosreportes") {
      if (txtReportTodos.current.checked) {
        txtReport1.current.checked = true;
       /*  txtReport2.current.checked = true;
        txtReport3.current.checked = true;
        txtReport4.current.checked = true;
        txtReport5.current.checked = true;
        txtReport6.current.checked = true; */
      } else {
        txtReport1.current.checked = false;
       /*  txtReport2.current.checked = false;
        txtReport3.current.checked = false;
        txtReport4.current.checked = false;
        txtReport5.current.checked = false;
        txtReport6.current.checked = false; */
      }
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.op === 1) {
          setOperacion(2);
          if (props.usuario.accvacios.toString().substring(0, 1) === '1') {
            setModu1(1);
          } else {
            setModu1(0);
          }

          if (props.usuario.accvacios.toString().substring(1, 2) === '1') {
            setModu2(1);
          } else {
            setModu2(0);
          }

          if (props.usuario.accvacios.toString().substring(2, 3) === '1') {
            setModu3(1);
          } else {
            setModu3(0);
          }

          if (props.usuario.accvacios.toString().substring(4, 5) === '1') {
            setModu4(1);
          } else {
            setModu4(0);
          }
          setHabilitado(false);
        } else {


          setHabilitado(true);
        }

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>Permisos de Usuario (Gestión de Vacios)</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>

          <div className="row col-md-12 rounded mx-auto m-0">

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-around' style={{ fontSizeAdjust: '0.6' }}>
              <legend className="float-none m-0 w-auto fs-6 fw-bold">Datos del Usuarios</legend>

              <div className='col-pd-200 px-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">USUARIO:</label>
                  <input type="text" ref={txtLogin} defaultValue={props.usuario && props.usuario.login} className="form-control text-uppercase fs-6" disabled={true} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <input type='hidden' ref={txtIduser} defaultValue={props.usuario && props.usuario.idusuario} />

              <div className='col-pd-180 px-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">CEDULA:</label>
                  <input type="text" ref={txtCedula} defaultValue={props.persona && props.persona.cedula} className="form-control text-uppercase fs-6" disabled={true} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className='col-pd-500 px-0'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">NOMBRES Y APELLIDOS:</label>
                  <input type="text" defaultValue={props.persona && props.persona.nombres.trim() + " " + props.persona.apellidos.trim()} className="form-control text-uppercase fs-6" disabled={true} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className='col-pd-170 px-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">ESTATUS:</label>
                  <input type="text" ref={txtStatus} defaultValue={props.usuario && props.usuario.status === '1' ? 'ACTIVO' : 'INACTIVO'} className="form-control text-uppercase fs-6 text-center" disabled={true} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </fieldset>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded'>
              <legend className="float-none m-0 w-auto fs-5 fw-bold">Modulos Autorizados</legend>

              {modu1 === 1 ? <div className="input-group col-sm-12 w-100 px-0 mb-1 border-azul">
                <div className="col-sm-5 fw-bold">Operaciones de Inventario (Vacios)</div>

                <table className="col-12 table table-sm table-bordered m-0 px-0">

                  <thead className="col-12 m-0 px-0">
                    <tr>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtuTodos}
                          defaultChecked={
                            props.usuario.btnopvacios.substring(0, 1) === '1' && props.usuario.btnopvacios.substring(1, 2) === '1' &&
                              props.usuario.btnopvacios.substring(2, 3) === '1' && props.usuario.btnopvacios.substring(3, 4) === '1' &&
                              props.usuario.btnopvacios.substring(4, 5) === '1' ? true : false
                          }
                          onChange={checkTodo} name='todos1' id="inlineCheckboxu" />
                        <label className="form-check-label" for="inlineCheckboxu">TODOS</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtuIncluir} defaultChecked={props.usuario.btnopvacios.substring(0, 1) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxu1" />
                        <label className="form-check-label" for="inlineCheckboxu1">INCLUIR</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtuModificar} defaultChecked={props.usuario.btnopvacios.substring(1, 2) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxu2" />
                        <label className="form-check-label" for="inlineCheckboxu2">MODIFICAR</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtuCosultar} defaultChecked={props.usuario.btnopvacios.substring(2, 3) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxu3" />
                        <label className="form-check-label" for="inlineCheckboxu3">CONSULTAR</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtuEliminar} defaultChecked={props.usuario.btnopvacios.substring(3, 4) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxu4" />
                        <label className="form-check-label" for="inlineCheckboxu4">ELIMINAR</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtuImprimir} defaultChecked={props.usuario.btnopvacios.substring(4, 5) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxu5" />
                        <label className="form-check-label" for="inlineCheckboxu5">IMPRIMIR</label>
                      </div></th>
                    </tr>
                  </thead>

                </table>

                <div />
              </div> : ''}

              {modu2 === 1 ? <div className="input-group col-sm-12 w-100 px-0 mb-1 border-azul">
                <div className="col-sm-5 fw-bold">Control de Vacios</div>

                <table className="col-12 table table-sm table-bordered m-0 px-0">

                  <thead className="col-12 m-0 px-0">
                    <tr>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtdTodos}
                          defaultChecked={
                            props.usuario.btncontvacios.substring(0, 1) === '1' && props.usuario.btncontvacios.substring(1, 2) === '1' &&
                            props.usuario.btncontvacios.substring(2, 3) === '1' && props.usuario.btncontvacios.substring(3, 4) === '1' &&
                            props.usuario.btncontvacios.substring(4, 5) === '1' ? true : false
                          }
                          onChange={checkTodo} name='todos2' id="inlineCheckboxd" />
                        <label className="form-check-label" for="inlineCheckboxd">TODOS</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtdModificar} defaultChecked={props.usuario.btncontvacios.substring(0, 1) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxd1" />
                        <label className="form-check-label" for="inlineCheckboxd1">ACTUALIZAR</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtdCosultar} defaultChecked={props.usuario.btncontvacios.substring(1, 2) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxd2" />
                        <label className="form-check-label" for="inlineCheckboxd2">MOSTRAR NOTA DE ENTREGA</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtdIncluir} defaultChecked={props.usuario.btncontvacios.substring(2, 3) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxd3" />
                        <label className="form-check-label" for="inlineCheckboxd3">INCLUIR</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtdEliminar} defaultChecked={props.usuario.btncontvacios.substring(3, 4) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxd4" />
                        <label className="form-check-label" for="inlineCheckboxd4">ELIMINAR</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtdImprimir} defaultChecked={props.usuario.btncontvacios.substring(4, 5) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxd5" />
                        <label className="form-check-label" for="inlineCheckboxd5">IMPRIMIR</label>
                      </div></th>
                    </tr>
                  </thead>

                </table>

                <div />
              </div> : ''}

              {modu3 === 1 ? <div className="input-group col-sm-12 w-100 px-0 mb-1 border-azul">
                <div className="col-sm-5 fw-bold">Clasificador de Vacios</div>

                <table className="col-12 table table-sm table-bordered m-0 px-0">

                  <thead className="col-12 m-0 px-0">
                    <tr>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txttTodos}
                          defaultChecked={
                            props.usuario.btnclasvacios.substring(0, 1) === '1' && props.usuario.btnclasvacios.substring(1, 2) === '1' &&
                              props.usuario.btnclasvacios.substring(2, 3) === '1' && props.usuario.btnclasvacios.substring(3, 4) === '1' &&
                              props.usuario.btnclasvacios.substring(4, 5) === '1' ? true : false
                          }
                          onChange={checkTodo} name='todos3' id="inlineCheckboxt" />
                        <label className="form-check-label" for="inlineCheckboxt">TODOS</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txttIncluir} defaultChecked={props.usuario.btnclasvacios.substring(0, 1) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxt1" />
                        <label className="form-check-label" for="inlineCheckboxt1">INCLUIR</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txttModificar} defaultChecked={props.usuario.btnclasvacios.substring(1, 2) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxt2" />
                        <label className="form-check-label" for="inlineCheckboxt2">MODIFICAR</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txttCosultar} defaultChecked={props.usuario.btnclasvacios.substring(2, 3) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxt3" />
                        <label className="form-check-label" for="inlineCheckboxt3">CONSULTAR</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txttEliminar} defaultChecked={props.usuario.btnclasvacios.substring(3, 4) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxt4" />
                        <label className="form-check-label" for="inlineCheckboxt4">ELIMINAR</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txttImprimir} defaultChecked={props.usuario.btnclasvacios.substring(4, 5) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxt5" />
                        <label className="form-check-label" for="inlineCheckboxt5">IMPRIMIR</label>
                      </div></th>
                    </tr>
                  </thead>

                </table>

                <div />
              </div> : ''}

              {modu4 === 1 ? <div className="input-group col-sm-12 w-100 px-0 border-azul">
                <div className="col-sm-5 fw-bold">Reportes</div>

                <table className="col-12 table table-sm table-bordered m-0 px-0">

                  <thead className="col-12 m-0 px-0">
                    <tr>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtReportTodos}
                          defaultChecked={
                            props.usuario.btnreportvacios.substring(0, 1) === '1' /* && props.usuario.btnreportvacios.substring(1, 2) === '1' &&
                              props.usuario.btnreportvacios.substring(2, 3) === '1' && props.usuario.btnreportvacios.substring(3, 4) === '1' &&
                              props.usuario.btnreportvacios.substring(4, 5) === '1' && props.usuario.btnreportvacios.substring(5, 6) === '1' */ ? true : false
                          }
                          onChange={checkTodo} name='todosreportes' id="inlineCheckboxr" />
                        <label className="form-check-label" for="inlineCheckboxr">TODOS</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtReport1} defaultChecked={props.usuario.btnreportvacios.substring(0, 1) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxr1" />
                        <label className="form-check-label" for="inlineCheckboxr1">"REPORTE CONTROL DE VACIOS"</label>
                      </div></th>
                      <input type='hidden' ref={txtReport2} value="false"/>
                      <input type='hidden' ref={txtReport3} value="false"/>
                      <input type='hidden' ref={txtReport4} value="false"/>
                      <input type='hidden' ref={txtReport5} value="false"/>
                      <input type='hidden' ref={txtReport6} value="false"/>
                      {/* <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtReport2} defaultChecked={props.usuario.btnreportvacios.substring(1, 2) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxr2" />
                        <label className="form-check-label" for="inlineCheckboxr2">...</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtReport3} defaultChecked={props.usuario.btnreportvacios.substring(2, 3) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxr3" />
                        <label className="form-check-label" for="inlineCheckboxr3">...</label>
                      </div></th> */}
                    </tr>
                    {/* <tr>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtReport4} defaultChecked={props.usuario.btnreportvacios.substring(3, 4) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxr4" />
                        <label className="form-check-label" for="inlineCheckboxr4">...</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtReport5} defaultChecked={props.usuario.btnreportvacios.substring(4, 5) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxr5" />
                        <label className="form-check-label" for="inlineCheckboxr5">...</label>
                      </div></th>
                      <th scope="col" className='p-1'><div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" ref={txtReport6} defaultChecked={props.usuario.btnreportvacios.substring(5, 6) === '1' ? true : false} onChange={checkBlank} id="inlineCheckboxr6" />
                        <label className="form-check-label" for="inlineCheckboxr6">...</label>
                      </div></th>
                    </tr> */}
                  </thead>

                </table>

                <div />
              </div> : ''}

            </fieldset>

          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className='col-md-4 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} disabled={props.usuario && props.usuario.status === '0' ? true : false} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-success"><i className="fas fa-check-circle">  Aceptar</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>
      </Modal.Footer>

    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/vacios/modalPermisosVacios.js